import { defineStore } from "pinia";
import { ref } from "vue";

export const useAuthStateStore = defineStore("auth-state", () => {
  const sessionExpired = ref(false);
  const redirectTo = ref(null);
  // True once this tab has confirmed an authenticated user profile.
  const hadAuthenticatedSession = ref(false);

  const markSessionExpired = (path = "/home") => {
    sessionExpired.value = true;
    redirectTo.value = path || "/home";
  };

  // Marks that this browser session had a valid login at least once.
  const markAuthenticatedSession = () => {
    hadAuthenticatedSession.value = true;
  };

  const clearSessionExpired = () => {
    sessionExpired.value = false;
    redirectTo.value = null;
  };

  const getSessionExpiredRoute = () => ({
    path: hadAuthenticatedSession.value ? "/session-expired" : "/login",
    query: {
      redirect_to: redirectTo.value ?? "/home",
    },
  });

  return {
    sessionExpired,
    redirectTo,
    hadAuthenticatedSession,
    markSessionExpired,
    markAuthenticatedSession,
    clearSessionExpired,
    getSessionExpiredRoute,
  };
});
